import React from 'react'
import PropTypes from 'prop-types'
import Link, { withPrefix } from 'gatsby-link'

import states from '../util/states'

const StateChangeSummary = ({ index, state, summary }) => (
  <div
    className="cmwf--state-change-summary">
    <Link className="cmwf--state-change-summary-link" to={ `/state/${ states[state].toLowerCase().replace(/ /g,"-") }` }>
      <div
        className="cmwf--state-change-summary--top">
        <div className="cmwf-state-img">
          <img src={ withPrefix(`/img/states/${state}.png`) } alt="" />
        </div>
        <div className={`cmwf-state-abbr cmwf--state-abbr-${state}`}>{state}</div>
      </div>
      <div className="cmwf--index"><span>{index}</span></div>
      <div
        className="cmwf--state-change-summary--bottom">
        <h3 className="cmwf--state-name">{states[state]}</h3>
        <p className="cmwf--summary">{summary}</p>
      </div>
    </Link>
  </div>
)

StateChangeSummary.propTypes = {
  index: PropTypes.number.isRequired,
  state: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
}

export default StateChangeSummary



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/state-change-summary.jsx